import {
    Box,
    CircularProgress,
    FormControl,
    FormControlLabel,
    makeStyles,
    Radio,
    RadioGroup,
} from "@material-ui/core";
import React, { useContext } from "react";
import { useState } from "react";
import { AppContext } from "../../../contexts/AppContext";
import assets from "../../../helpers/assets";
import Colors from "../../../helpers/Colors";
import {
    DELIVERY_IN_HOUSE,
    DELIVERY_THIRD_PARTY,
} from "../../../helpers/Constants";
import { getFromStorage } from "../../../services/LocalStorage";
import { updateLocationDeliveryConfig } from "../../../services/OrderService";
import Text from "../Text";

export function DeliveryMethod() {
    const {
        authData,
        kitchen,
        defaultDeliveryMode,
        availableDeliveryModes,
        setDefaultDeliveryMode,
    } = useContext(AppContext);

    const classes = useStyles();
    const [showProgressBar, setShowProgressBar] = useState(false)

    const onDeliveryModeChange = (event) => {
        let loadedKitchen = kitchen;
        if (!loadedKitchen.id) {
            loadedKitchen = getFromStorage("kitchen");
        }

        const deliveryMode = event.target.value;
        setShowProgressBar(true)
        updateLocationDeliveryConfig(
            authData.signInUserSession.idToken.payload.partner_id,
            loadedKitchen.id,
            {
                locationId: loadedKitchen.id,
                defaultDeliveryMode: deliveryMode,
                availableDeliveryModes: availableDeliveryModes,
            }
        )
            .then((response) => {
                setDefaultDeliveryMode(deliveryMode);
                setShowProgressBar(false)
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <Box className={classes.container}>
            <Box className={classes.titleSection}>
                <img
                    src={assets.helmet.default}
                    alt=""
                    className={classes.titleIcon}
                />
                <Text className={classes.title}>Delivery Method</Text>
            </Box>
            <Box className={classes.contentSection}>
                <Text className="">
                    By selecting one of these methods it will become your default
                    delivery method.
                </Text>
                <FormControl
                    className={classes.radioGroup}
                    disabled={availableDeliveryModes.length < 2}
                >
                    <RadioGroup
                        row
                        value={defaultDeliveryMode}
                        onChange={onDeliveryModeChange}
                        color="success"
                    >
                        <FormControlLabel
                            value={DELIVERY_IN_HOUSE}
                            control={<Radio />}
                            label="In House"
                            style={{ marginRight: 120 }}
                        />
                        <FormControlLabel
                            value={DELIVERY_THIRD_PARTY}
                            control={<Radio />}
                            label="3 PL"
                        />
                    </RadioGroup>
                </FormControl>
            </Box>
            <Box className={classes.progress} style={{display: showProgressBar ? "flex" : "none"}}>
                <CircularProgress />
            </Box>
        </Box>
    );
}

const useStyles = makeStyles((theme) => ({
    container: {
        color: Colors.textColor,
        padding: 25,
        fontFamily: "SFProDisplay-Medium",
        display: "flex",
        flexDirection: "column",
        height: "100%"
    },
    titleSection: {
        display: "flex",
        alignItems: "center",
        marginBottom: 12,
    },
    titleIcon: {
        width: 20,
        height: 20,
        marginRight: 12,
    },
    contentSection: {
        marginLeft: 32,
        fontSize: 14,
    },
    radioGroup: {
        marginTop: 12,
        "& .MuiRadio-root": {
            color: "#1C1B1F",
        },
        "& .Mui-checked": {
            color: Colors.grubtechBlue,
        },
        "& .Mui-disabled": {
            color: Colors.textColor,
            opacity: 0.7,
        },
    },
    title: {
        fontFamily: "SFProDisplay-Bold",
        fontSize: 24,
    },
    progress: {
        display: "flex",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        "& .MuiCircularProgress-circle": {
            color: Colors.grubtechBlue
        }
    }
}));
